import Storage from '@medlinker/storage';

/**
 * 公共存储
 */
export const commonStorage = new Storage({
  namespace: 'ih-common',
});

/**
 * 用户相关存储
 */
export const userStorage = new Storage({
  namespace: 'ih-user',
});
